import { GeometricAvatar } from '../shared/GeometricAvatar';

export const UsernameSetup = ({
  showUsernameSetup,
  showEditProfile,
  setShowEditProfile,
  setShowUsernameSetup,
  usernameInput,
  setUsernameInput,
  usernameError,
  setUsernameError,
  MAX_USERNAME_LENGTH,
  MIN_USERNAME_LENGTH,
  canChangeUsername,
  bioInput,
  setBioInput,
  MAX_BIO_LENGTH,
  saveUsername,
  username,
}) => {
  if (!showUsernameSetup) return null;

  return (
    <div className="fixed inset-0 z-[9000] bg-black/95 flex items-start sm:items-center justify-center p-4 overflow-y-auto" style={{ zIndex: 9000 }}>
      <div className="bg-gradient-to-br from-gray-900 to-black border-4 border-lime-500 p-6 sm:p-8 max-w-md w-full relative z-[10000] my-8 sm:my-0">
        <h2 className="text-3xl sm:text-4xl font-black text-lime-500 uppercase mb-4">
          {showEditProfile ? 'EDIT PROFILE' : 'CHOOSE USERNAME'}
        </h2>
        <p className="text-gray-400 text-sm font-bold mb-6">
          {showEditProfile
            ? 'Update your profile details below.'
            : "Pick a name that represents your sender energy. This is how you'll appear in the community."}
        </p>

        <div className="mb-4">
          <label className="block text-lime-400 font-black text-sm mb-2 uppercase">Username</label>
          <input
            type="text"
            value={usernameInput}
            onChange={(e) => {
              setUsernameInput(e.target.value);
              setUsernameError('');
            }}
            onFocus={(e) => {
              setTimeout(() => {
                e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }, 300);
            }}
            placeholder="YourUsername"
            maxLength={MAX_USERNAME_LENGTH}
            disabled={showEditProfile && !canChangeUsername().allowed}
            className="w-full bg-black border-3 border-lime-500 p-4 text-lime-500 placeholder-gray-600 font-black text-lg focus:outline-none focus:border-yellow-500 uppercase disabled:opacity-50 disabled:cursor-not-allowed"
            autoFocus={!showEditProfile}
          />
          <div className="flex items-center justify-between mt-2">
            <span className="text-xs font-bold text-gray-500">
              {usernameInput.length}/{MAX_USERNAME_LENGTH}
            </span>
            <span className="text-xs font-bold text-gray-500">
              Letters, numbers, underscores only
            </span>
          </div>

          {showEditProfile && !canChangeUsername().allowed && (
            <div className="bg-orange-900 border-2 border-orange-500 p-3 mt-2">
              <p className="text-orange-200 font-bold text-sm">
                Username locked for {canChangeUsername().daysRemaining} more days
              </p>
            </div>
          )}

          {usernameError && (
            <div className="bg-red-900 border-2 border-red-500 p-3 mt-3">
              <p className="text-red-200 font-bold text-sm">{usernameError}</p>
            </div>
          )}
        </div>

        <div className="mb-4">
          <label className="block text-lime-400 font-black text-sm mb-2 uppercase">Bio (Optional)</label>
          <input
            type="text"
            value={bioInput}
            onChange={(e) => setBioInput(e.target.value)}
            onFocus={(e) => {
              setTimeout(() => {
                e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }, 300);
            }}
            placeholder="One line about your vibe..."
            maxLength={MAX_BIO_LENGTH}
            className="w-full bg-black border-3 border-purple-500 p-4 text-purple-500 placeholder-gray-600 font-bold text-base focus:outline-none focus:border-purple-400"
          />
          <div className="flex items-center justify-between mt-2">
            <span className="text-xs font-bold text-gray-500">
              {bioInput.length}/{MAX_BIO_LENGTH}
            </span>
            <span className="text-xs font-bold text-gray-500">
              Optional • Keep it short
            </span>
          </div>
        </div>

        <div className="mb-6">
          <p className="text-gray-500 text-xs font-bold">
            Browsing anonymously? You can explore first. To buy SendIt Pass, link and verify an email in your profile; use that same email at checkout.
          </p>
        </div>

        {usernameInput.length >= MIN_USERNAME_LENGTH && !usernameError && (
          <div className="mb-6 flex items-center gap-3 p-3 bg-black border-2 border-yellow-500">
            <GeometricAvatar username={usernameInput} size={48} />
            <div>
              <p className="text-yellow-400 font-black text-sm uppercase">YOUR AVATAR</p>
              <p className="text-gray-500 text-xs font-bold">Auto-generated from username</p>
            </div>
          </div>
        )}

        <button
          onClick={saveUsername}
          disabled={usernameInput.length < MIN_USERNAME_LENGTH || (showEditProfile && !canChangeUsername().allowed && usernameInput !== username)}
          className="w-full bg-gradient-to-r from-lime-500 to-green-600 hover:from-lime-400 hover:to-green-500 text-black py-4 font-black text-xl uppercase border-3 border-lime-400 transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:grayscale"
        >
          {showEditProfile ? '✓ SAVE CHANGES' : 'LOCK IT IN'}
        </button>

        {showEditProfile && (
          <button
            onClick={() => {
              setShowEditProfile(false);
              setShowUsernameSetup(false);
              setUsernameInput('');
              setBioInput('');
              setUsernameError('');
            }}
            className="w-full bg-gray-800 hover:bg-gray-700 text-gray-400 py-3 font-black text-base uppercase border-2 border-gray-700 transition-all mt-2"
          >
            CANCEL
          </button>
        )}
      </div>
    </div>
  );
};
